module.exports = __webpack_public_path__ + "img/newDot.cc97520a.svg";